import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { OutputService } from '../../../infrastructure/services/output.service';
import { Location } from '@angular/common';
import { AlertService, GrowlType } from 'app/infrastructure/services/alert.service';
import { QueryBuilderConfig } from 'app/plugins/queryBuilder';
import { RuleBuilderService, EmptyRuleBuilder } from 'app/infrastructure/services/ruleBuilder.service';
import { INgxSelectOption } from 'ngx-select-ex';
import { FieldMap } from 'app/plugins/queryBuilder/components';
import { MappingOutputAttribute } from 'app/infrastructure/model/classes/output.classes';
import { TypeOptions, OperationPrototypes } from 'app/infrastructure/model/interfaces/rulePrototype.interface';

@Component({
    selector: 'sx-mappingDetails-output',
    templateUrl: './mappingDetails.output.component.html',
})
export class MappingDetailsOutputComponent implements OnInit {
    systemCode: string;
    outputCode: string;
    mappingId: string;

    outputConst = 'outputAttribute';
    newConst = 'new';

    attributeModel:
        MappingOutputAttribute = {
            attribute: '',
            type: 'String',
        };

    // data types
    opciones = TypeOptions;

    sources = [
        'documentAttribute',
        'documentComponent',
        'outputAttribute'
    ];

    targetKeys = [];
    targetFields = [];

    isNew = false;
    selectedSource = 'documentAttribute';
    operationTypes = OperationPrototypes;
    mapperFields: FieldMap = null;
    loaded = false;

    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private outputService: OutputService,
        private location: Location,
        private alertService: AlertService,
        private ruleService: RuleBuilderService
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.systemCode = params['codsistema'];
            this.outputCode = params['codoutput'];
            this.mappingId = params['mappingId'];

            this.ruleService.getForOutputConfiguration(this.systemCode,this.outputCode)
                .subscribe(config => {
                    const ff = config.fields;
                    this.mapperFields = ff;
                    if (this.mappingId !== this.newConst) {
                        this.isNew = false;
                        this.outputService
                            .getAttribute(this.systemCode, this.outputCode, this.mappingId)
                            .subscribe(data => {
                                this.attributeModel = data;
                                this.loaded = true;
                            });
                    } else {
                        this.isNew = true;
                        this.attributeModel.systemCode = this.systemCode;
                        this.attributeModel.outputCode = this.outputCode;
                        this.loaded = true;
                    }
                });
        });
    }

    back(): void {
        this.location.back();
    }

    save(): void {
        this.outputService.saveAttribute(this.attributeModel).then(a => {
            this.alertService.showGrowl({
                type: GrowlType.SUCCESS,
                body: 'OUTPUT_ATTRIUBUTE_SUCCESS',
            }, { name: a.attribute });
            this.back();
        });
    }

    getChange(event) {
        this.attributeModel.mappingRule = event;
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/mapping/mappingDetails.output.component.ts